export default {
  productType: {
    Ok: '确定',
    Search: '查询',
    Cancel: '取消',
    TypeName: '分类名称',
    OptionalAttribute: '可选属性',
    SuperiorTypeName: '上级分类名称',
    status: '状态',
    TypeDesc: '分类描述',
    CreateTime: '创建日期',
    // 新增分类
    BasicInfo: '基本信息',
    SuperiorType: '上级分类',
    Desc: '描述',
    Picture: '图片',
    Specs: '规格',
    AddRow: '添加',
    SpecName: '规格名称',
    ChooseSuperiorType: '选择上级分类',
    ChooseProductType: '选择商品分类',
    Code: '编号',
    Name: '名称',
    PleaseEnterTypeName: '请输入分类名称',
    SelectAtLeastOneAttribute: '至少选择一个属性'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn/pmc/productType.js